'use strict';exports.__esModule = true;exports.default =




createStore;var _redux = require('redux');var _reactRouterRedux = require('react-router-redux');var _reduxLoop = require('redux-loop');var _clientMiddleware = require('./middleware/clientMiddleware');var _clientMiddleware2 = _interopRequireDefault(_clientMiddleware);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  var composeParams = [
  (0, _redux.applyMiddleware)((0, _clientMiddleware2.default)(client)),
  (0, _reduxLoop.install)(),
  (0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(history))];


  if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__) {
    composeParams.push(
    window.devToolsExtension ? window.devToolsExtension() : require('../utils/DevTools/DevTools').instrument(),
    // eslint-disable-next-line import/no-extraneous-dependencies
    require('redux-devtools').persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)));

  }

  var finalCreateStore = _redux.compose.apply(undefined, composeParams)(_redux.createStore);
  var reducer = require('./modules/reducer');
  var store = finalCreateStore(reducer, data);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./modules/reducer', function () {return store.replaceReducer(require('./modules/reducer'));});
  }

  return store;
}module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/create.js
// module id = 3115
// module chunks = 0